export const GET_SCHEDULE = {
  BEGIN: 'GET_SCHEDULE_BEGIN',
  SUCCESS: 'GET_SCHEDULE_SUCCESS',
  FAILURE: 'GET_SCHEDULE_FAILURE'
}
